/// <reference path="../../../teva/selectbox/selectbox.ts" />

namespace OfficeGuy.Apps {
    export class SMS {
        static InitEditors(Container = null) {
            $("textarea.og-smseditor, .og-sms-text textarea", Container).each(function () {
                SMS.InitEditor($(this));
            });
        }
        static InitEditor($Textarea) {
            $Textarea
                .off("input.smseditor")
                .on("input.smseditor", function () {
                    SMS.RefreshSummary($Textarea);
                });
            SMS.RefreshSummary($Textarea);
        }

        static InitMailingListEditor() {
            $(".og-sms-view .viewpicker, .og-sms-view .schemapicker").on("change", function () {
                var Schema = Teva.SelectBox.GetInstance($(".og-sms-view .schemapicker"));
                var View = Teva.SelectBox.GetInstance($(".og-sms-view .viewpicker"));
                Teva.SelectBox.GetInstance($(".og-sms-namefield .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
                Teva.SelectBox.GetInstance($(".og-sms-phonefield .schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
                Teva.SelectBox.GetInstance($(".og-sms-namefield .viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
                Teva.SelectBox.GetInstance($(".og-sms-phonefield .viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
            });
        }

        static RefreshSummary($Textarea) {
            var Length = $Textarea.val().length;
            var Units;
            if (Length <= 70)
                Units = 1;
            else
                Units = Math.floor(Length / 67) + (Length % 67 == 0 ? 0 : 1);
            var Container = $Textarea.closest(".og-entity-property");
            if (Container.length == 0) {
                Container = $Textarea.closest(".sumit-field-value");
                if (Container.length == 0)
                    Container = $Textarea.parent();
            }
            var $Summary = Container.find(".sms-summary");
            if ($Summary.length == 0)
                $Summary = $(document.createElement('div'))
                    .addClass("sms-summary")
                    .appendTo(Container);
            $Summary
                .html("אורך ההודעה: " + Length + " תווים.<br />כמות הודעות לנמען: " + Units + ".")
                .toggle(Length > 0);
        }

        static RefreshBlock() {
            var Enabled = $(".og-sms-block-type input").val() == "3" || $(".og-sms-block-type input").val() == "RemoveSpecificList";
            $(".og-sms-block-mailinglist").toggle(Enabled);
        }

        static TemplateSelected($EntityPicker) {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData;
            $(".og-sms-text textarea").val(!Data || !Data.AdditionalFields ? "" : Data.AdditionalFields["SMS.Templates.Text"]).trigger("change");
            SMS.RefreshSummary($(".og-sms-text textarea"));
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Apps.SMS.InitEditors(Container);
});
